export default __webpack_public_path__ + "static/media/ic_download.3f3656d3.svg";